import React, { useState, useEffect } from "react";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import "./listeningnotyfy.scss";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { encode } from "base-64";
import { notificationlistdetailAction } from "../../actions/notificationAction";
import moment from "moment";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import { notificationsearchAction, notificationpageAction } from "../../actions/notificationAction";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { notify } from '../../services/notification';
import { dowloadnotificationlistAction } from "../../actions/exceldownloadAction";
import { constant } from "../../constants/constant";
import { MOBILE_BREAKPOINT, HTTP_STATUS } from "../../constants/constant";
import { HiMenu, HiX } from "react-icons/hi";
import useMobileView from "../../constants/useMobileView";


function NotificationListening() {
  const [notificationList, setnotificationList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { isSidebarOpen, toggleSidebar } = useMobileView();



  const [count, setCount] = useState(1);
  const searchedData = useSelector((state) => state?.notifySearch);
  const pagedata = useSelector((state) => state.notifypage);
  const [inputValue, setInputValue] = useState(
    searchedData?.searchnotificationdata?.data?.value
  );
  const [criteria, setcriteria] = useState(
    searchedData?.searchnotificationdata?.data?.criteria
  );
  const [page, setPage] = useState(pagedata?.page);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    notificationListData();
  }, [page]);



  async function handleCriteriaChange(event) {
    setIsLoading(true);
    setcriteria(event.target.value);
    setPage(1);
    setInputValue("");
    var seardata = {
      criteria: event.target.value,
      value: "",
    };
    dispatch(notificationsearchAction(seardata));
    let response = await dispatch(notificationlistdetailAction(page));
    if (response == 200 || response != null) {
      setIsLoading(false);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10));
      } else {
        setCount(Math.floor(response.data.count / 10 + 1));
      }
      setnotificationList(response.data.results.data);
    }
  }



  const handleChange = (event) => {
    const value = event.target.value
    setInputValue(value);
    if (value.length === 0) {
      window.location.reload()
    }
  };

  async function notificationListData() {
    setIsLoading(true);
    if (inputValue == "" || criteria == "") {
      var response = await dispatch(notificationlistdetailAction(page));
    } else {
      var response = await dispatch(notificationlistdetailAction(page, inputValue, criteria));
    }
    if (response == 200 || response != null) {
      setIsLoading(false);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10));
      } else {
        setCount(Math.floor(response.data.count / 10 + 1));
      }
      setnotificationList(response.data.results.data);
      setpaginationListcount(response.data.count);
    }
  }

  async function onSearch() {
    if (criteria === '') {
      notify.error('Please select Criteria .')
      return false
    }
    if (inputValue === '') {
      notify.error('Please enter search data.')
      return false
    }
    setIsLoading(true)
    var seardata = {
      criteria: criteria,
      value: inputValue,
    };
    dispatch(notificationsearchAction(seardata));
    let response = await dispatch(notificationlistdetailAction(constant.defaultPage, inputValue, criteria));
    if (response == 200 || response != null) {
      setIsLoading(false);
      if (response.data.count % 10 == 0) {
        setCount(Math.floor(response.data.count / 10))
      }
      else {
        setCount(Math.floor((response.data.count / 10) + 1))
      }
      setPage(1);
      setnotificationList(response.data.results.data);
      setpaginationListcount(response.data.count);
    }
  }

  async function downloadnotificationlist() {
    try {
      const fileBlob = await dispatch(dowloadnotificationlistAction(page, inputValue, criteria));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          notify.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const handlePagiChange = (event, value) => {
    dispatch(notificationpageAction(value));
    setPage(value);
  };

  const notificationDetails = (Id) => {
    window.scroll(0, 0);
    const encodeid = encode(Id);
    navigate(`/editnotification/${encodeid}`);
  };

  function createNotification() {
    navigate("/createnotification");
  }

  function createNotificationExcel() {
    navigate("/createnotificationexcel");
  }

  const [paginationListcount, setpaginationListcount] = useState(0);
  const startItem = notificationList?.length === 0 ? 0 : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min(page * constant.paginationCount, paginationListcount);

  function isNotificationExpired(starting_date, starting_time) {
    const notificationTime = moment(`${starting_date} ${starting_time}`, "YYYY-MM-DD HH:mm:ss");
    return moment().isAfter(notificationTime);
  }

  return (
    <div className="Create_Containers">
      <div className="Create_container">
        <Header title="Notification List" />
        <div className="View__Training">
          <div className="notification_search">
            <div className="notification_label">
              <div className="input-label">
                <select
                  name="searchTitle"
                  id="cars"
                  className="search-dropdown-field-notification"
                  value={criteria}
                  onChange={handleCriteriaChange}
                >
                  <option value="">Select Criteria </option>
                  <option value="title">Heading </option>
                  <option value="date">Date</option>
                </select>
                {criteria === "date" ?
                  <input
                    type="date"
                    id="date"
                    placeholder="dd/mm/yy"
                    className="search-input-field-notification"
                    name="nameValue"
                    disabled={criteria === undefined || criteria === ""}
                    value={inputValue}
                    onChange={handleChange}
                  />
                  :
                  <input
                    type="search"
                    className="search-input-field-notification"
                    placeholder="Enter a Value"
                    name="nameValue"
                    disabled={criteria === undefined || criteria === ""}
                    value={inputValue}
                    onChange={handleChange}
                  />
                }
                <button className="search-noty-list-btn"
                  disabled={inputValue === "" || inputValue === undefined || criteria === undefined || criteria === ""}
                  onClick={onSearch}>Search</button>
                <button
                  type="button"
                  className="create-notification-button"
                  onClick={createNotification}
                >
                  + Create Notification
                </button>
                <button
              type="button"
              className="create-notification-excel-button"
              onClick={createNotificationExcel}
            >
              + Create Notification Excel
            </button>
            <div className="bottom-label">
                <button className="download-excel-button" onClick={downloadnotificationlist}>
                  <img src={Image_Url.EXCEL_LOGO} className="download-excel-icon" />
                  Download Excel
                </button>
              </div>
              </div>
              
            </div>
          </div>

          <div className="table__data">
            {notificationList.length > 0 ? (
              <div className="Final">
                <table className="table">
                  <tr>
                    <th className="notification-heading-text">Notification Heading</th>
                    <th className="tablesth">Date</th>
                    <th className="tablesth">Time</th>
                    <th className="tablesth">Action</th>
                  </tr>
                  {notificationList.map((data) => (
                    <tr>
                      <td className="tabletd table-heading-text">{data.title}</td>
                      <td className="tabletd">
                        {moment.utc(data.starting_date).format("DD/MM/YYYY")}
                      </td>
                      <th className="tabletd">
                        {moment(data.starting_time, ["HH.mm"]).format(
                          "hh:mm A"
                        )}
                      </th>
                      <td className="tabletdV">
                        <div className="card_profile_controls">
                          {!isNotificationExpired(data.starting_date, data.starting_time) && (
                            <img
                              src={Image_Url.EDIT}
                              className="editicons"
                              onClick={() => {
                                notificationDetails(data.id);
                              }}
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </table>
              </div>
            ) : (
              <div> {isLoading === true ? <Loader /> : <NoDataFound />} </div>
            )}
            <div className="Pagination_section">
              <Stack spacing={2}>
                <Pagination
                  count={count}
                  className="pagination"
                  page={page}
                  size="medium"
                  defaultPage={1}
                  color="primary"
                  onChange={handlePagiChange}
                />
              </Stack>
              <div className="count">
                <b>
                  <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default NotificationListening;